module.exports = __webpack_public_path__ + "static/media/business-hub-primary.d250badd.jpg";